import Box from "@mui/material/Box";
import Skeleton from "../../../../../CommonComponents/Skeleton";


export const SOALearningStreakSkeleton = () => {
  return (
    <Box
      sx={{
        width: '100%',
        height: "192px",
        padding: "24px",
        background: "#FFFFFF",
        display: "flex",
        flexDirection: "column",borderRadius:"8px"
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom:"5px"
        }}
      >
        <Skeleton sx={{width:"151px",height:"30px"}} animation="wave"/>
        <Skeleton sx={{width:"128px",height:"32.14px",borderRadius:"30px"}} animation="wave"/>
      </Box>

      <Skeleton sx={{width:"77px",height:"24px",marginBottom:"15px"}} animation="wave"/>
      <Box
        sx={{
          display: "flex",
          // width:"408px",
          height:"56px",
          gap:"20px",
          margin:"20px 0px 0px 10px"
        }}
      >
        {Array.from({ length: 7 }).map((_, i) => (
            <Skeleton key={i} animation="wave" sx={{height:"56px",width:"70px"}}/>
        ))}
      </Box>
    </Box>
  );
};
